import React from 'react';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';

const AnimatedButton = ({ buttonName, className, handleClick,link,disabled ,locnState,datatestid}) => {
    const location=useNavigate()
    return (
        <motion.button
            type='button'
            disabled={disabled?disabled:null}
            data-testid={datatestid}
            whileHover={disabled?'':{ scale: 1.02 }}
            whileTap={disabled?'':{ scale: 0.9 }}
            className={className}
            onClick={(e) => {
                if(link){
                    if(locnState!==undefined){
                        location(link,{state:locnState})
                    }
                    else{
                        location(link)
                    }
                    
                }else{
                    handleClick(e)
                }}}
            id={buttonName}
        >
            {buttonName}
        </motion.button>
    );
}

export default AnimatedButton;
